import React, { memo, SVGAttributes } from 'react';

export const CollectionPremiumEmptyStateIllustration = memo(
  function CollectionPremiumEmptyStateIllustration(
    props: SVGAttributes<HTMLOrSVGElement>,
  ) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        {...props}
      >
        <path
          d="M89.9246 29.7913L2.30566 46.458L14.3605 109.832L101.979 93.165L89.9246 29.7913Z"
          fill="white"
        />
        <path
          d="M90.559 33.1349L21.7036 46.2324L33.1231 106.266L101.978 93.1684L90.559 33.1349Z"
          fill="#C2E2FF"
        />
        <path
          d="M80.4949 86.0762L110.94 93.8697C112.587 94.2561 113.611 95.9017 113.23 97.5497L108.5 116.05C108.039 117.682 106.344 118.635 104.71 118.18L74.4399 110.43C73.6468 110.244 72.9598 109.751 72.5303 109.059C72.1009 108.367 71.964 107.533 72.1499 106.74L76.8799 88.2397C77.3287 86.6693 78.9191 85.7326 80.4949 86.0762ZM89.3352 26.6708L90.9722 35.2765L3.35326 51.9431L1.71631 43.3374L89.3352 26.6708ZM61.5199 3.96973L63.5099 27.1997L31.9999 33.0697L27.6399 11.3597L39.2299 19.8197L45.3899 6.96973L53.3399 17.0397L61.5199 3.96973Z"
          fill="#116DFF"
        />
        <path
          d="M86.9894 40.1707L89.9046 55.4959L31.099 66.6817L28.1839 51.3565L86.9894 40.1707ZM7.31988 45.54C7.9771 45.54 8.50988 46.0728 8.50988 46.73C8.50988 47.3872 7.9771 47.92 7.31988 47.92C6.66266 47.92 6.12988 47.3872 6.12988 46.73C6.12988 46.0728 6.66266 45.54 7.31988 45.54ZM11.8499 44.68C12.5071 44.68 13.0399 45.2127 13.0399 45.87C13.0399 46.5272 12.5071 47.06 11.8499 47.06C11.1927 47.06 10.6599 46.5272 10.6599 45.87C10.6599 45.2127 11.1927 44.68 11.8499 44.68ZM16.2199 43.85C16.8771 43.85 17.4099 44.3828 17.4099 45.04C17.4099 45.6972 16.8771 46.23 16.2199 46.23C15.5627 46.23 15.0299 45.6972 15.0299 45.04C15.0299 44.3828 15.5627 43.85 16.2199 43.85Z"
          fill="white"
        />
        <path
          d="M23.4093 48.1216L34.4213 106.014L14.4101 109.82L3.39807 51.9281L23.4093 48.1216ZM76.5614 89.4936L112.909 98.7991L112.019 102.277L75.671 92.9714L76.5614 89.4936ZM73.7861 52.1598L73.9728 53.1422L35.2557 60.4999L35.069 59.5175L73.7861 52.1598ZM56.8072 50.5216L56.9939 51.504L34.3688 55.8036L34.1821 54.8212L56.8072 50.5216ZM92.5212 12.3009L92.8614 13.2413L71.4309 20.9948L71.0907 20.0545L92.5212 12.3009ZM75.6169 6.86035L76.3681 7.52048L68.2946 16.707L67.5435 16.0469L75.6169 6.86035Z"
          fill="#192C55"
        />
        <path
          d="M44.6799 86.5904L104.36 57.6504L117.12 83.8904L57.4399 112.83L44.6799 86.5904Z"
          fill="white"
        />
        <path
          d="M104.83 56.33L104.86 56.36L118.49 84.36L56.9998 114.17L43.3398 86.12L104.83 56.33ZM95.6687 62.9894L54.7584 82.8081C55.5908 84.9982 55.6307 87.4217 54.8535 89.6517C54.0157 92.0555 52.2944 94.0452 50.0461 95.2213L49.9918 95.248L53.7034 102.87C58.4059 101.01 63.8018 102.97 66.1966 107.47L107.326 87.5417C105.411 82.8753 107.288 77.4904 111.698 75.0275L108.077 67.5871C103.401 69.3966 98.0594 67.4465 95.6687 62.9894ZM74.9709 79.0503C78.3928 75.7803 83.8207 75.9066 87.0945 79.3325C90.3684 82.7583 90.2483 88.1864 86.8265 91.4564C83.4046 94.7264 77.9767 94.6001 74.7029 91.1742C71.4291 87.7484 71.5491 82.3203 74.9709 79.0503Z"
          fill="#28BF9A"
        />
      </svg>
    );
  },
);
